/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EonAccount } from '../models/EonAccount';
import { Pagination } from '../models/Pagination';

export class AccountsResponse {
  'accounts'?: Array<EonAccount>;
  'pagination'?: Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accounts",
      "baseName": "accounts",
      "type": "Array<EonAccount>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AccountsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

